module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-149175550-1","head":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gramat Gril","short_name":"Gramat Gril","start_url":"/","background_color":"#f7f7f7","theme_color":"#8db600","display":"standalone","icon":"src/images/favicon.png","include_favicon":false,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"b2055e8126a614faa6869507c7747037"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
